import React from 'react';

export const Nested = (props: {
  components: React.ElementType[];
  children: React.ReactElement;
}) => {
  let element: React.ReactElement = props.children;
  for (const comp of [...props.components].reverse()) {
    element = React.createElement(comp, {}, element);
  }
  return element;
};
